// Costanti UI condivise (label stato, cause, esiti) — sincronizzate con backend e shared/constants.js
export const APP_NAME = 'Road Hub';
export const APP_VERSION = 'v1.30.3';

export const STATI_CHIAMATA: Record<string, { label: string; color: string }> = {
  nuova: { label: 'Aperta', color: '#ef4444' },
  assegnata: { label: 'Assegnata', color: '#0ea5e9' },
  presa_in_carico: { label: 'Presa in carico', color: '#7c3aed' },
  report_squadra: { label: 'Report Squadra', color: '#f59e0b' },
  chiusa: { label: 'Chiusa', color: '#22c55e' },
  sospesa: { label: 'Da terminare', color: '#d97706' },
  annullata: { label: 'Annullata', color: '#94a3b8' },
};

// Costanti stato come STRINGHE (da usare nei confronti/invio al backend)
export const STATI = {
  NUOVA: 'nuova',
  ASSEGNATA: 'assegnata',
  PRESA_IN_CARICO: 'presa_in_carico',
  REPORT_SQUADRA: 'report_squadra',
  CHIUSA: 'chiusa',
  SOSPESA: 'sospesa',
  ANNULLATA: 'annullata',
} as const;

// Gruppi dashboard (ordine di visualizzazione)
export const GRUPPI_DASHBOARD = [
  { key: 'aperte', label: 'Aperte', color: '#ef4444' },
  { key: 'assegnate', label: 'Assegnate', color: '#0ea5e9' },
  { key: 'prese_in_carico', label: 'Prese in carico', color: '#7c3aed' },
  { key: 'report_squadra', label: 'Report Squadra', color: '#f59e0b' },
  { key: 'chiuse', label: 'Chiuse', color: '#22c55e' },
  { key: 'sospese', label: 'Da terminare', color: '#d97706' },
  { key: 'annullate', label: 'Annullate', color: '#94a3b8' },
];

export const ESITI_BASE: Record<string, { label: string; color: string }> = {
  risolto: { label: 'Risolto', color: '#22c55e' },
  parzialmente_risolto: { label: 'Parzialmente risolto', color: '#f59e0b' },
  non_risolto: { label: 'Non risolto', color: '#ef4444' },
};

// Esiti specifici per impianti di tipo IS (impianto semaforico) — SOLO queste 3 voci
export const ESITI_IS: Record<string, { label: string; color: string }> = {
  lasciato_acceso_colori: { label: 'Lasciato acceso a colori', color: '#22c55e' },
  lasciato_acceso_lampeggio: { label: 'Lasciato acceso a lampeggio', color: '#22c55e' },
  lasciato_spento: { label: 'Lasciato spento', color: '#22c55e' },
};

// Mappa completa di tutti gli esiti possibili (standard + IS) — per visualizzazione/read
export const ESITI: Record<string, { label: string; color: string }> = ESITI_BASE;
export const ESITI_COMPLETO: Record<string, { label: string; color: string }> = {
  ...ESITI_BASE,
  ...ESITI_IS,
};

export const STATI_IMPIANTO: Record<string, string> = {
  spento: 'Spento',
  acceso_colori: 'Acceso a colori',
  lampeggio: 'Lampeggio',
  altro: 'Altro',
};

export const STATI_IMPIANTO_LISTA = ['spento', 'acceso_colori', 'lampeggio', 'altro'] as const;

export const TIPI_IMPIANTO = {
  IS: 'Impianto semaforico',
  BT: 'Bluetooth',
  SM: 'Stazione di misura',
  APL: 'Attraversamento Pedonale Luminoso',
  SML: 'Segnaletica Luminosa Solare / Lampada',
  TE: 'Pannello a messaggio variabile',
  CL: 'Cartello Luminoso / Pannello',
  AB: 'Pannello a messaggio variabile',
  IG: 'Pannello a messaggio variabile',
  MT: 'Pannello a messaggio variabile',
  Lp: 'Lampeggiante di Pericolo',
  GV: 'Pannello a messaggio variabile',
  PA: 'Passaggio a Livello / Accesso',
  IN: 'Indicatore di Corsia',
  LI: 'Illuminazione / Segnalatore',
} as const;

// Lista ordinata delle sigle per la selezione del tipo impianto (con IS in cima)
export const TIPI_IMPIANTO_LISTA = [
  'IS',
  'TE',
  'SM',
  'APL',
  'SML',
  'AB',
  'CL',
  'MT',
  'Lp',
  'IG',
  'BT',
  'GV',
  'PA',
  'IN',
  'LI',
] as const;

// ===== ODL (Ordini Di Lavoro) =====
export const STATI_ODL: Record<string, { label: string; color: string }> = {
  aperto: { label: 'Aperto', color: '#6366f1' },
  assegnato: { label: 'Assegnato', color: '#0ea5e9' },
  preso_in_carico: { label: 'In Lavorazione', color: '#7c3aed' },
  da_terminare: { label: 'Da Terminare', color: '#d97706' },
  concluso: { label: 'Concluso', color: '#22c55e' },
  annullato: { label: 'Annullato', color: '#94a3b8' },
};

export const GRUPPI_ODL = [
  { key: 'tutti', label: 'Tutti', color: '#64748b' },
  { key: 'aperti', label: 'Aperti', stato: 'aperto', color: '#6366f1' },
  { key: 'assegnati', label: 'Assegnati', stato: 'assegnato', color: '#0ea5e9' },
  { key: 'in_lavorazione', label: 'In Lavorazione', stato: 'preso_in_carico', color: '#7c3aed' },
  { key: 'da_terminare', label: 'Da Terminare', stato: 'da_terminare', color: '#d97706' },
  { key: 'conclusi', label: 'Conclusi', stato: 'concluso', color: '#22c55e' },
  { key: 'annullati', label: 'Annullati', stato: 'annullato', color: '#94a3b8' },
];

export const PRIORITA_ODL: Record<string, { label: string; color: string }> = {
  bassa: { label: 'Bassa', color: '#64748b' },
  normale: { label: 'Normale', color: '#0ea5e9' },
  urgente: { label: 'Urgente', color: '#ef4444' },
};

export const CAUSE_GUASTO = [
  { value: 'guasto_elettrico', label: 'Guasto elettrico' },
  { value: 'guasto_controller', label: 'Guasto controller' },
  { value: 'guasto_lanterna', label: 'Guasto lanterna' },
  { value: 'guasto_rilevatore', label: 'Guasto rilevatore' },
  { value: 'urto_veicolare', label: 'Urto veicolare' },
  { value: 'allagamento', label: 'Allagamento' },
  { value: 'manutenzione_programmata', label: 'Manutenzione programmata' },
  { value: 'altro', label: 'Altro' },
];

export const AZIONI_ESEGUITE = [
  { value: 'sostituito', label: 'Sostituito' },
  { value: 'riparato', label: 'Riparato' },
  { value: 'verificato', label: 'Verificato' },
  { value: 'pulito', label: 'Pulito' },
  { value: 'regolato', label: 'Regolato' },
  { value: 'altro', label: 'Altro' },
];

export const RUOLI = { OPERATORE: 'operatore', SQUADRA: 'squadra' } as const;
export const PERMESSI = {
  ADMIN: 'admin',
  OPERATIVO: 'operativo',
  LETTURA: 'lettura',
  COMMITTENTE: 'committente',
} as const;

// Utility per selezione multipla con separatore " - "
export function toggleMultiOpzione(current: string, opzione: string): string {
  const items = current
    ? current.split(/\s*-\s*/).map((s) => s.trim()).filter(Boolean)
    : [];
  const idx = items.findIndex((it) => it.toLowerCase() === opzione.toLowerCase());
  if (idx >= 0) {
    items.splice(idx, 1);
  } else {
    items.push(opzione);
  }
  return items.join(' - ');
}

export function isMultiOpzioneSelected(current: string, opzione: string): boolean {
  if (!current) return false;
  const items = current.split(/\s*-\s*/).map((s) => s.trim().toLowerCase());
  return items.includes(opzione.toLowerCase());
}

// Finestra "online": squadra vista negli ultimi 240 minuti (4 ore)
export const SQUADRA_ONLINE_MINUTI = 240;

export const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const MAX_FOTO_PER_REPORT = 10;
export const MAX_FOTO_SEGNALAZIONE = 5;

export const API_BASE_URL = '/api';

export const TIPI_EVENTO_AVVISO = {
  IN_VIGORE: 'IN_VIGORE',
  SCADUTO: 'SCADUTO',
  REVOCATO: 'REVOCATO',
} as const;

export type TipoEventoAvviso = typeof TIPI_EVENTO_AVVISO[keyof typeof TIPI_EVENTO_AVVISO];

export const STATI_SEGNALAZIONE = {
  aperta: { label: 'Aperta', color: '#f59e0b' },
  convertita: { label: 'Convertita in Chiamata', color: '#10b981' },
  archiviata: { label: 'Archiviata', color: '#94a3b8' },
} as const;
